<script setup>
import { computed } from 'vue';

const props = defineProps({
  numeros: {
    type: Array,
    required: true
  }
});

const numerosOrdenados = computed(() => [...props.numeros].sort((a, b) => a - b));

const codigosForaDeOrdem = computed(() => {
  return props.numeros
    .map((valor, index) => ({ valor, index }))
    .filter(({ valor }, index) => valor !== numerosOrdenados.value[index])
    .map(({ valor }) => valor);
});


const codigosFaltantes = computed(() => {
  const faltantes = [];
  const min = 0;
  const max = Math.max(...props.numeros);

  for (let i = min; i <= max; i++) {
    if (!props.numeros.includes(i)) {
      faltantes.push(i);
    }
  }

  return faltantes;
});

const codigosRepetidos = computed(() => {
  const contagem = props.numeros.reduce((acc, num) => {
    acc[num] = (acc[num] || 0) + 1;
    return acc;
  }, {});

  return Object.keys(contagem)
    .filter(num => contagem[num] > 1)
    .map(Number);
});
</script>

<template>
  <div>
    <div class="alert alert-outline-danger mb-3 w-100 small" v-if="codigosFaltantes.length">
      <p>
        Atenção:
        {{ codigosFaltantes.length > 1
        ? `Os atos de códigos ${codigosFaltantes.join(', ')} não constam entre os atos listados.`
        : `O ato de código ${codigosFaltantes[0]} não consta entre os atos listados.` }}
      </p>
    </div>

    <div class="alert alert-outline-danger mb-3 w-100 small" v-if="codigosRepetidos.length">
      <p>
        Atenção: Existem atos listados com códigos repetidos ({{ codigosRepetidos.join(', ') }}).
      </p>
    </div>

    <div class="alert alert-outline-warning mb-3 w-100 small" v-if="codigosForaDeOrdem.length">
      <p>
        Atenção:
        {{ codigosForaDeOrdem.length > 1
        ? `Os atos de códigos ${codigosForaDeOrdem.join(', ')} não estão na ordem correta entre os atos listados.`
        : `O ato de código ${codigosForaDeOrdem[0]} não está na ordem correta entre os atos listados.` }}
      </p>
    </div>
  </div>
</template>

<style scoped>

</style>
